// extracted by mini-css-extract-plugin
export default {"barwrappermain":"BarWrapper_barwrappermain__PsCgR"};